const content = (
  <div>
    <p>
      Cette formation vous offre une immersion totale dans les principes
      fondamentaux du management, vous équipant des compétences indispensables
      pour diriger avec succès et efficacité.
    </p>
    <h2>Programme de formation</h2>
    <p>
      Cette formation fournit les clés essentielles pour être un manager
      efficace : Comprendre la dynamique de groupe, renforcer la cohésion
      d'équipe, gérer le temps, identifier les priorités et les urgences,
      planifier collectivement et assurer le suivi individuel des
      collaborateurs.
    </p>
    <p>
      Une bonne organisation du travail permet de faire avancer les projets dans
      un climat serein, et même en cas de changements ou de gestion de
      personnalités difficiles.
    </p>
    <p>Trouver la meilleure posture sera un gage de réussite.</p>
    <p>
      Cette formation vous apporte ou vous rappelle les fondamentaux
      opérationnels pour gérer au quotidien votre équipe.
    </p>
    <h2>Public Concerné</h2>
    <p>Les managers, ou responsables d’équipe en poste ou futurs managers</p>
    <h2>Prérequis</h2>
    <p>Aucun prérequis excepté une expérience de travail minimum de 2 ans</p>
    <h2>Objectifs pédagogiques :</h2>
    <p>À l’issue de la formation, le participant sera en mesure de :</p>
    <ul>
      <li> Gérer efficacement son temps et celui de son équipe</li>
      <li> Évaluer les priorités et les urgences des activités</li>
      <li>
        Diriger et superviser les travaux de l'équipe en comprenant la notion de
        groupe
      </li>
      <li> Pratiquer la communication assertive et savoir refuser</li>
      <li> Faire accepter les décisions et les changements</li>
      <li> Résoudre les conflits au sein de l'équipe</li>
      <li> Adopter la posture managériale adéquate</li>
    </ul>
    <p>
      Durée : 2 jours de 9 h00 à 17h, soit 7 heures effectives de formation par
      jour
    </p>
    <p>
      Durée : A distance, avec ou sans regroupements, en partie à distance et en
      partie en présentiel
    </p>
    <p>
      Organisation : A distance, avec ou sans regroupements, en partie à
      distance et en partie en présentiel
    </p>
    <p>En intra ou inter entreprise</p>
    <p>Taille du groupe : jusqu’à 10 stagiaires</p>
    <p>Lieux</p>
    <p>En intra : Chez le client</p>
    <p>En inter : Des salles de formation sont proposées à Paris</p>
    <h2>Accessibilité</h2>
    <p>
      Pour toute situation de handicap merci de nous contacter pour envisager la
      faisabilité
    </p>
    <h2>Délai et modalités d'accès</h2>
    <p>
      Jusqu'à 48h avant le début de la formation et en fonction des plannings
    </p>
    <h2>Tarifs</h2>
    <p>1.200 Euros hors taxes pour les 2 jours de formation par stagiaire</p>

    <h2>1/ Comprendre le fonctionnement d'un groupe au travail</h2>

    <p>Analyser la dynamique de groupe.</p>
    <p>Appréhender les attentes et besoins du groupe.</p>
    <p>Situer le rôle de l'équipe dans l'entreprise.</p>
    <p>Positionner chaque individu dans le fonctionnement du groupe.</p>
    <p>Identifier les capacités de chaque collaborateur.</p>
    <p>Collecter les critères de réussite du travail en groupe.</p>
    <p>Identifier et gérer les différentes personnalités.</p>
    <p>Faire partager sa vision et les valeurs de l'entreprise.</p>
    <h3>Travaux pratiques</h3>
    <p>
      Jeu de présentation du groupe, réflexion sur la dynamique créée et les
      bénéfices du travail en groupe.
    </p>

    <h2>2/ Faire le bilan sur sa propre gestion du temps</h2>
    <p>Mesurer sa perception et sa relation au temps.</p>
    <p>Représenter l'utilisation de son temps.</p>
    <p>
      Réfléchir sur les points forts de son organisation et aux pertes de temps.
    </p>
    <p>
      Quantifier le temps passé en réunion, au téléphone, en RDV, en
      déplacement...
    </p>
    <p>Élaborer ses nouveaux objectifs et définir ses points de progrès.</p>
    <h3>Travaux pratiques</h3>
    <p>Évaluation de sa relation au temps à l'aide d'un auto-positionnement</p>

    <h2>3/ Priorité ou urgence</h2>
    <p>
      Classer les activités selon le principe d'Eisenhower : important et
      urgent.
    </p>
    <p>Faire le point sur le niveau prioritaire des activités.</p>
    <p>Déterminer le temps des tâches de ses collaborateurs.</p>
    <p>S'approprier les règles d'une organisation efficace.</p>
    <p>Utiliser les outils de la planification.</p>
    <p>Savoir organiser les tâches de ses collaborateurs dans le temps.</p>
    <h3>Travaux pratiques</h3>
    <p>
      Définir ses priorités avec la matrice d'Eisenhower, puis débriefing et
      atelier de coaching
    </p>

    <h2>4/ Organiser le travail collectif</h2>
    <p>Identifier les temps de travail collectifs actuels.</p>
    <p>Répertorier les missions et tâches de son équipe.</p>
    <p>Identifier les résistances rencontrées dans l'optimisation du temps.</p>
    <p>Analyser les compétences des équipes.</p>
    <p>
      Évaluer la motivation des collaborateurs pour la répartition des
      activités.
    </p>
    <p>
      Prendre en compte les besoins individuels et collectifs dans
      l'organisation des activités.
    </p>
    <p>Adapter son management au niveau de maturité des collaborateurs.</p>
    <p>
      Évaluer le profil relationnel de ses collaborateurs pour gagner du temps
      dans les échanges.
    </p>
    <p>Mettre en place un plan de délégation efficace.</p>
    <h3>Travaux pratiques</h3>
    <p>
      Répertorier les missions et les tâches de son équipe. Élaborer un plan de
      délégation.
    </p>

    <h2>5/ Piloter et suivre l'activité de son équipe</h2>
    <p>Définir les règles de l'équipe en termes de suivi</p>
    <p>Fixer des objectifs collectifs et individuels avec la méthode SMART</p>
    <p>Piloter avec des tableaux de bord</p>
    <p>Choisir des indicateurs de suivi</p>
    <p>Définir et formaliser des plans d'actions individuels et collectifs</p>
    <p>
      Suivre les actions dans le temps : mettre en place les entretiens de suivi
    </p>
    <p>Formuler des feedbacks constructifs et des signes de reconnaissance</p>
    <p>Encourager sur les résultats obtenus et à atteindre</p>
    <h3>Travaux pratiques</h3>
    <p>
      Construction en sous-groupes d'un plan d'actions avec des objectifs SMART
    </p>

    <h2>6/ Évaluer l'impact du changement sur l'organisation de l'activité</h2>
    <p>Comprendre les étapes de l'acceptation au changement.</p>
    <p>Savoir communiquer pour préparer le changement.</p>
    <p>Comprendre les réactions de l'équipe face aux changements.</p>
    <p>Évaluer l'impact du changement sur l'organisation de l'activité.</p>
    <p>Faire adhérer l'équipe au changement.</p>
    <p>
      Améliorer sa capacité à expliquer et à donner du sens aux décisions
      prises.
    </p>
    <p>Agir pour maintenir l'implication dans la durée.</p>
    <h3>Travaux pratiques</h3>
    <p>
      Jeux de rôles : Communiquer et faire adhérer au changement. Exercice
      pratique sur les freins et les solutions à proposer.
    </p>

    <h2>7/ Organiser sa communication managériale</h2>

    <p>Connaître les règles de base de la communication.</p>
    <p>
      Utiliser les différentes formes de communication : digitale, réunion,
      entretien...
    </p>
    <p>Utiliser le management situationnel pour adapter sa communication.</p>
    <p>Organiser des temps d'échanges collectifs et individuels.</p>
    <p>Utiliser la communication assertive pour renforcer son leadership.</p>
    <p>Écouter activement, questionner, savoir reformuler.</p>
    <p>
      Utiliser l'empathie comme source de compréhension de soi et des autres.
    </p>
    <p>Gérer les sollicitations et interruptions.</p>
    <p>Savoir formuler ses demandes. Savoir dire "non".</p>
    <h3>Travaux pratiques</h3>
    <p>
      Mises en situation filmées en utilisant la fonction vidéo du téléphone
      autour de la communication : savoir dire non, être assertif, pratiquer
      l'écoute active et le questionnement... Débriefing en groupe.
    </p>

    <h2>
      8/ Organiser les relations de l'équipe au quotidien : gérer les tensions
    </h2>

    <ul>
      <li>
        Désamorcer les tensions. Les trois cerveaux : à la base de nos
        réactions.
      </li>
      <li>Comprendre et gérer ses réactions.</li>
      <li>Comprendre les mécanismes du triangle dramatique.</li>
      <li>Comprendre les comportements et y faire face.</li>
      <li>Gérer ses émotions et pensées négatives.</li>
      <li>
        Canaliser ses propres tensions ainsi que celles de ses collaborateurs.
      </li>
      <li>Maîtriser les étapes de résolution des désaccords.</li>
      <li>Anticiper les situations et relations difficiles.</li>
    </ul>
    <h3>Travaux pratiques</h3>
    <p>
      Jeux de rôles filmés sur la gestion de la relation conflictuelle, et
      atelier de coaching sur des problématiques factuelles des participants
    </p>

    <h2>Modalités pratiques</h2>
    <h3>Travaux pratiques</h3>
    <p>
      Partage d'expériences. Mises en situation filmées puis analysées, jeux de
      rôles, test et autodiagnostics, études de cas...
    </p>

    <h2>Modalités d'évaluation</h2>
    <h3>Travaux pratiques</h3>
    <p>
      Le formateur évalue la progression pédagogique du participant tout au long
      de la formation au moyen de QCM, mises en situation, travaux pratiques…
    </p>
    <p>
      Le participant complète également un test de positionnement en amont et en
      aval pour valider les compétences acquises.
    </p>

    <h2>Modalités pratiques</h2>
    <h3>Travaux pratiques</h3>
    <p>Mise en situation, auto prospection/diagnostic, et cas pratiques</p>
    <h3>Méthodes pédagogiques</h3>
    <p>
      Pédagogie active basée sur des échanges, une évaluation tout au long de la
      formation et de nombreux exercices de mise en application.
    </p>
    <h2>Modalités d'évaluation</h2>
    <p>
      Tout au long de la session de formation, le formateur suit l'avancement
      pédagogique du participant grâce à divers outils tels que des
      questionnaires à choix multiples, des simulations pratiques et d'autres
      exercices appliqués. De plus, le participant réalise un test de
      positionnement avant et après la formation afin de confirmer les
      compétences développées.
    </p>
  </div>
);

export default content;
